module.exports = global["sma"] = require("-!/Users/ernestof/projects/fluidreview/node_modules/babel-loader/lib/index.js??ref--1!./index.js");


//////////////////
// WEBPACK FOOTER
// ../node_modules/expose-loader?sma!../apps/chide/products/smapply/static/sma.applicant/index.js-exposed
// module id = 2331
// module chunks = 2